import EmbeddedContent from '@components/EmbeddedContent'
import config from '@config'
import { CookWidget } from '@widgets/types'
import { FunctionComponent } from 'react'
import styled from 'styled-components'
import { SportradarFixturesProps, ValidSportradarFixturesProps } from './types'
import { isValidSportradarFixturesProps } from './utils'

type CreateEmbedUrlType = (
  ...args: [
    matchId: ValidSportradarFixturesProps['matchId'],
    tournamentId: ValidSportradarFixturesProps['tournamentId'],
    typeOfSport: ValidSportradarFixturesProps['typeOfSport']
  ]
) => string

const {
  sportradar: { sportradarFixturesStaticPageUrl },
} = config

const StyledFixtures = styled.div`
  min-height: 300px; // height of widget with no data available yet
`

const createEmbeddedUrl: CreateEmbedUrlType = (
  matchId,
  tournamentId,
  typeOfSport
) =>
  `${sportradarFixturesStaticPageUrl}?matchId=${matchId}&typeOfSport=${typeOfSport}&tournamentId=${tournamentId}`

const SportradarFixtures: FunctionComponent<SportradarFixturesProps> = (
  props
) => {
  if (!isValidSportradarFixturesProps(props)) {
    return null
  }

  const { matchId, tournamentId, typeOfSport } = props

  return (
    <StyledFixtures>
      <EmbeddedContent
        maxHeight={500}
        scrollingEnabled
        url={createEmbeddedUrl(matchId, tournamentId, typeOfSport)}
      />
    </StyledFixtures>
  )
}

const widget: CookWidget = {
  kind: ['widget', 'sportradar-fixtures'],
  component: SportradarFixtures,
}

export default widget
